<template>
  <div v-if="permissionNotesManagementPackageComputed" class="popup-window-center">
    <div class="popup-body documents-popup">
      <div class="card card-small documents-popup__card">
        <div class="card-header documents-popup__header">
          <div class="documents-popup__title">
            <span class="material-icons">folder</span>
            {{ $t('general.documents.documents') }}
          </div>
          <div class="documents-popup__header-actions">
            <d-button class="documents-popup__upload" @click="showUploadPopupFunc">
              <span class="material-icons">upload_file</span>
              {{ $t('general.documents.upload') }}
            </d-button>
            <button type="button" class="documents-popup__close" @click="close">
              <span class="material-icons">close</span>
            </button>
          </div>
        </div>

        <div class="card-body documents-popup__body">

        <div v-if="documentsLst.length" class="content-container-overflow">
          <table class="table table-striped-custom table-hover-custom mb-0">
            <thead class="bg-light">
            <tr>
              <th scope="col" class="border-0" width="40%">{{ $t('general.documents.document') }}</th>
              <th scope="col" class="border-0" width="30%">{{ $t('general.documents.dateUploaded') }}</th>
              <th scope="col" class="border-0" width="30%">{{ $t('general.documents.uploadedBy') }}</th>
              <th scope="col" class="border-0 menu-cell"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="document in documentsLst" :key="document.id">
              <td>{{ document.documentTitle }}</td>
              <td>{{ formatDate(document.dateCreated) }}</td>
              <td>{{ document.uploaderName }}</td>
              <td>
                <span class="link link-secondary link-hover d-flex align-items-center justify-content-end" @click="removeDocument(document.id)">
                  <span class="material-icons">delete</span>
                  {{ $t('general.documents.remove') }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
          <div v-else class="documents-popup__empty">
            <span class="material-icons">folder_open</span>
            <span>{{ $t('general.documents.documents') }}</span>
          </div>
          <div class="documents-popup__footer">
            <button type="button" class="documents-popup__cancel" @click="close">
              {{ $t('general.documents.close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showUploadPopup" class="upload-popup-layer">
      <UploadPopup v-on:close-upload="closeUploadPopupFunc"
                   :record-type="recordType"
                   :record-id="recordId"
      ></UploadPopup>
    </div>
  </div>
</template>

<script>
import UploadPopup from '@/components/General/Documents/UploadPopup';
import documentsService from '@/services/documents.service';

export default {
  name: 'DocumentsPopup',
  components: { UploadPopup },
  props: {
    recordId: {
      required: true,
      type: [Number, String],
    },
    recordType: {
      required: true,
      type: Object,
      default() {
        return {
          entity: '',
          fieldName: '',
        };
      },
    },
  },
  data() {
    return {
      documentsLst: [],
      showUploadPopup: false,
    };
  },
  created() {
    this.getDocuments();
  },
  methods: {

    async getDocuments() {
      this.$store.commit('changeShowLoader', true);
      await documentsService.list({ [this.recordType.fieldName]: this.recordId })
        .then((data) => {
          if (data) {
            this.documentsLst = data.data;
          } else {
            throw 'Server return status false';
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.documents'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    async removeDocument(documentId) {
      this.$confirm(this.$t('general.documents.deleteNoteConfirmation'), undefined, undefined, { confirmButtonText: this.$t('generalMessages.Ok'), cancelButtonText: this.$t('generalMessages.cancel') }).then(async () => {
        this.$store.commit('changeShowLoader', true);
        await documentsService.remove(documentId)
          .then((data) => {
            if (data) {
              this.$toast.success(this.$t('general.documents.deletionSucssefully'));
              this.getDocuments();
            } else {
              throw 'Server return status false';
            }
          })
          .catch((err) => {
            this.showError(err, this.$t('errors.entities.document'), 'delete');
          });
        this.$store.commit('changeShowLoader', false);
      });
    },
    close() {
      this.$emit('close');
    },
    showUploadPopupFunc() {
      setTimeout(() => {
        this.showUploadPopup = true;
      }, 50);
    },
    closeUploadPopupFunc(reload = false) {
      this.showUploadPopup = false;
      if (reload) {
        this.getDocuments();
      }
    },
  },
  computed: {
    permissionNotesManagementPackageComputed() {
      return this.hasFeature('follow-ups');
    },
  },
};
</script>

<style scoped>
.documents-popup {
  width: min(920px, calc(100vw - 32px));
}
.documents-popup__card {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 22px 64px rgba(24, 45, 66, .24);
  margin: 0 !important;
  overflow: hidden;
}
.documents-popup__header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--fitnet-surface-border-color, #e5ecf2);
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;
}
.documents-popup__title {
  align-items: center;
  color: var(--fitnet-heading-color);
  display: flex;
  font-size: 1.15rem;
  font-weight: 700;
  gap: 9px;
}
.documents-popup__title .material-icons {
  color: var(--fitnet-primary);
  font-size: 22px;
}
.documents-popup__header-actions {
  align-items: center;
  display: flex;
  gap: 8px;
  position: relative;
}
.documents-popup__upload {
  align-items: center;
  border-radius: 9px;
  display: inline-flex;
  gap: 6px;
}
.documents-popup__upload .material-icons {
  font-size: 18px;
}
.documents-popup__close {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fitnet-muted-text-color);
  display: inline-flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}
.documents-popup__close:hover,
.documents-popup__close:focus {
  background: rgba(0, 152, 184, .09);
  color: var(--fitnet-primary);
}
.documents-popup__body {
  padding: 20px;
}
.content-container-overflow {
  border: 1px solid var(--fitnet-surface-border-color, #e5ecf2);
  border-radius: 10px;
  max-height: 300px;
  overflow-y: auto;
}
.content-container-overflow .table th {
  background: #f6fafc;
  color: var(--fitnet-heading-color);
  font-size: .75rem;
  font-weight: 700;
}
.content-container-overflow .table td {
  color: var(--fitnet-text-color);
  vertical-align: middle;
}
.documents-popup__empty {
  align-items: center;
  border: 1px dashed var(--fitnet-surface-border-color, #dce5ed);
  border-radius: 10px;
  color: var(--fitnet-muted-text-color);
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  min-height: 120px;
}
.documents-popup__empty .material-icons {
  color: #a9b8c6;
  font-size: 30px;
}
.documents-popup__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.documents-popup__cancel {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--fitnet-muted-text-color);
  padding: 7px 10px;
}
.documents-popup__cancel:hover,
.documents-popup__cancel:focus {
  background: rgba(0, 152, 184, .09);
  color: var(--fitnet-primary);
}
.upload-popup-layer {
  align-items: center;
  background: rgba(0, 0, 0, .38);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 1rem;
  position: fixed;
  z-index: 2;
}
@media (max-width: 575px) {
  .documents-popup {
    width: calc(100vw - 20px);
  }
  .documents-popup__body,
  .documents-popup__header {
    padding: 14px;
  }
  .documents-popup__upload {
    font-size: 0;
    height: 36px;
    justify-content: center;
    padding: 0 !important;
    width: 36px;
  }
  .documents-popup__upload .material-icons {
    font-size: 18px;
  }
  .upload-popup-layer { padding: .625rem; }
}
</style>
